import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Form, Subtext } from '@contently/toolkit';

import LocalizedDateRange from '../toolkit/localized_date_range';
import { get, endpoint } from '../../../utils/shared/api';
import { handleError } from '../../utils/errors';
import ContentPortalHeader from './header';
import AggregateEvents from './aggregate_events';
import StoryEvents from './story_events';
import LoadingMask from '../toolkit/loadingMask';

const DateRangePickerWrapper = styled('div')``;

const ContentPortal = props => {
  const { appData } = props;
  const { brandProfileId, contentPortalId } = JSON.parse(appData);
  const [portal, setPortal] = useState();
  const [eventData, setEventData] = useState();
  const [dates, setDates] = useState({startDate: null, endDate: null});
  const [contentFetching, setContentFetching] = useState(false);
  const [aggregateFetching, setAggregateFetching] = useState(false);

  const fetchContentPortalData = () => {
    get(`/api/v1/brand_profiles/${brandProfileId}/content_portals/${contentPortalId}`).then(json => setPortal(json));
  };

  const fetchContentPortalEventData = () => {
    const params = {
      from_date: dates.startDate,
      to_date: dates.endDate
    };
    setAggregateFetching(true);
    get(
      endpoint(`/api/v1/analytics/${brandProfileId}/content_portal_aggregate_events/${contentPortalId}`, params),
      false
    )
      .then(json => {
        setEventData(json);
        setAggregateFetching(false);
      })
      .catch(error => handleError(error));
  };

  const handleDatesChange = (fromDate, toDate) => {
    setDates({startDate: fromDate, endDate: toDate});
  };

  useEffect(() => {
    if (dates.startDate && dates.endDate) {
      fetchContentPortalEventData();
    }
  }, [dates]);

  useEffect(() => {
    fetchContentPortalData();
  }, []);

  if (!portal) return null;

  return (
    <LoadingMask active={contentFetching || aggregateFetching}>
      <Fragment>
        <ContentPortalHeader name={portal.name}>
          <DateRangePickerWrapper>
            <Form.DateRangePicker
              onDatesChange={handleDatesChange}
            />
            <Subtext>
              <LocalizedDateRange dates={dates} />
            </Subtext>
          </DateRangePickerWrapper>
        </ContentPortalHeader>
        <AggregateEvents data={eventData} />
        <StoryEvents
          brandProfileId={brandProfileId}
          dates={dates}
          setFetching={setContentFetching}
          contentPortalId={contentPortalId}
        />
      </Fragment>
    </LoadingMask>
  );
};

ContentPortal.propTypes = {
  appData: PropTypes.string.isRequired
};

export default ContentPortal;



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_portals/content_portal.jsx